import storage from "redux-persist/lib/storage";
import {
  persistReducer,
  persistStore,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from "redux-persist";
import { root, persist } from "../redux/Reducers";
import { combineReducers, configureStore } from "@reduxjs/toolkit";

const persistConfig = {
  key: "stocksTradingCheckList",
  storage,
  whitelist: ["persist"],
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({ root, persist }),
);

export const store = configureStore({
  devTools: process.env.NODE_ENV !== "production",
  preloadedState: {},
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);
